<app-dialog
  customClass="offer-dialog"
  [hideActions]="true"
  [dialogType]="dialogType"
  [trackingScreenName]="trackingScreenName"
  [trackingObject]="trackingObject"
>
  <ng-container *ngIf="offer$ | async as offer; else loader">
    <div class="banner-image-wrapper">
      <img
        alt="banner"
        class="banner-image"
        [hidden]="!imageLoadingComplete$"
        [src]="offer.image"
        (load)="onImageLoad()"
      />
    </div>
    <div
      *ngIf="imageLoadingComplete$ | async; else loader"
      class="dialog-content"
    >
      <p class="title">{{ offer.header }}</p>

      <p class="subtitle">{{ offer.body }}</p>

      <div class="cta-buttons">
        <button
          *ngFor="let button of offer.ctas"
          class="cta-button"
          i2gButton
          [buttonStyle]="
            button.type === this.offerCtaTypeEnum.primary
              ? 'emphasis'
              : 'default'
          "
          trackable
          [trackingObject]="trackingObject"
          [trackingAction]="buildButtonTappedTrackingAction(button.type)"
          (click)="handleDeeplink(button.uri)"
        >
          {{ button.title }}
        </button>
      </div>
    </div>
  </ng-container>

  <ng-template #loader>
    <div class="loading-dialog-content">
      <app-icon class="loading-spinner" [icon]="loadingSpinnerIcon"> </app-icon>
    </div>
  </ng-template>
</app-dialog>
